import type {uuid} from '@/@types/entity';
import type Invoice from '@/entities/invoice';

type InvoiceOwner = Pick<Invoice, 'leadId' | 'matterId'>;

/**
 * An invoice's one Case as a list, for comparing with a transaction's matterIds and for the
 * lookups that take a list. Empty on an invoice with no Case, such as a consult on a Lead.
 * An invoice's null matterId must not reach ArrayMap.getMappingFor: that key holds every
 * invoice with no Case.
 */
export const invoiceCaseIds = (invoice: InvoiceOwner): uuid[] => invoice.matterId ? [invoice.matterId] : [];

/** What an invoice bills, as FinancialHelper.getMoneyAllocation takes it: its Lead, else its Case. */
export const invoiceOwnerIds = (invoice: InvoiceOwner): uuid[] =>
    invoice.leadId ? [invoice.leadId] : invoiceCaseIds(invoice);
